<template>
  <div class="top">
  <swiper class="swiper" :options="swiperOption">
    <swiper-slide>
        <img class="hide-sp" src="@/assets/firstview-0a2399dc555cbfd59e5e87bc1dde3242.jpg" alt="">
        <img class="hide-pc" src="@/assets/firstview-sp-2748906bce0886c004e9b190eb989531.jpg" alt="">
        <div class="top-copy">
            <h1>
                人生を変える
                <br>
                プログラミングスクール
            </h1>
            <p class="bold">
                <span class="hide-sp">未経験から</span>テクノロジーで理想のキャリアを手に入れる
            </p>
        </div>
    </swiper-slide>
    <swiper-slide>
        <img class="hide-sp"  src="@/assets/firstview-online-b62ae8ec49568f5330aedc96de02c3c0.jpg" alt=""> 
        <img class="hide-pc" src="@/assets/firstview-online_sp-b54ec1a8571f0292e055a98020104d0b.jpg" alt=""> 
        <div class="top-online">
            <div class="top-online-copy">
                <h1>
                    <span>オンライン</span>
                    でも
                    <br>
                    <span>挫折しない環境</span>
                    がここにある
                </h1>
                <p>国内最大級のプログラミングスクール</p>

            </div>
        </div>
        </swiper-slide>
    <div class="swiper-pagination swiper-pagination-black" slot="pagination"></div>
  </swiper>
  </div>
</template>

<script>

  export default {
    name: 'swiper-example-default',
    title: 'Default',
    
    data() {
      return {
        swiperOption: {
            loop: true,
            effect: 'fade',
            spaceBetween: 100,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },autoplay: {
            delay: 5000,
            disableOnInteraction: false
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './base.scss';
  img {
      width: 100%;
      height: auto;
  }
  .top-copy {
      text-align:left;
    color: #fff;
    text-shadow: 0 0 8px rgba(0,0,0,0.3);
    position: absolute;
    top: 53%;
    left: 3%;
    transform: translateY(-50%);
  }

.top-online-copy {
        width: 100%;
    position: absolute;
    top: 53%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    text-align: center;
}

  .top-online-copy h1{
      color: #121212;
        font-size: 3rem;
        letter-spacing: 0.03em;
        font-weight: 900;
        line-height: 1.4;
        margin-bottom: 10px;
        text-shadow: 0px 0px 2px rgba(255,255,255,0.3);
  }

  .top-online-copy span {
      font-size: 4rem;
  }

  @media screen and (max-width: 767px) {
    .top {
      padding-top: 80px;
    }

    .top-copy {
      font-size: 1rem;
      color: black;
      text-align: center;
      top: 20%;
    }

    .top-online-copy {
      font-size: 1rem;
      top: 20%;

    }

    .top-online-copy h1 {
      display: block;
      line-height: 1.3;
      font-size: 1rem;
      background: none;
      margin: 0 0 .2em;
    }

    .top-online-copy span {
      font-size: 1.8rem;
    }

  }
</style>